module.exports = __webpack_public_path__ + "static/media/builtinv2-Frame 6.08805e49.png";